import React from "react";
import { FaqDropdown } from "../../../components/faq-dropdown";
import { Main } from "../../../layouts/main";

import { Container } from "./styles";

const initialState = {
  0: false,
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
};

export const Surgeon: React.FC = () => {
  const [state, setState] = React.useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });
  return (
    <Main>
      <Container>
        <FaqDropdown
          marginTop={1}
          state={state[0]}
          content={"Como realizo meu cadastro?"}
          onClick={() => {
            setState((old) => (old = { ...initialState, 0: !old[0] }));
          }}
        >
          Na nossa página inicial, apresentamos um botão "ENVIAR GUIA", clique e
          será direcionado ao fomulário de entrega da guia. Lembre-se de
          identificar corretamente o CIRURGIÃO e Anexar sua Guia Autorizada.
        </FaqDropdown>
        <FaqDropdown
          marginTop={1}
          state={state[1]}
          content={"É obrigatório ter secretariado? "}
          onClick={() => {
            setState((old) => (old = { ...initialState, 1: !old[1] }));
          }}
        >
          Não. O cirurgião é autonomo no processo de marcação da cirurgia,
          contudo na nossa versão inicial (MVP). Será necessário que o cirurgião
          realize login no Portal WEB do Secretariado para continuação do
          processo. (Utilizar mesmo LOGIN e SENHA).
        </FaqDropdown>
        <FaqDropdown
          marginTop={1}
          state={state[2]}
          content={"Posso indicar a secretária após finalizado meu cadastro? "}
          onClick={() => {
            setState((old) => (old = { ...initialState, 2: !old[2] }));
          }}
        >
          Não, uma vez realizado o cadastro sem secretária, nossa versão MVP não
          permite essa mudança.
          <br />
          Não esqueça! Nossa plataforma está em constante atualização
        </FaqDropdown>
        <FaqDropdown
          marginTop={1}
          state={state[3]}
          content={"Posso utilizar aplicativo com qualquer plano de saúde? "}
          onClick={() => {
            setState((old) => (old = { ...initialState, 3: !old[3] }));
          }}
        >
          Não, uma vez realizado o cadastro sem secretária, nossa versão MVP não
          permite essa mudança.<br/>Não esqueça! Nossa plataforma está em constante
          atualização
        </FaqDropdown>
        <FaqDropdown
          marginTop={1}
          state={state[4]}
          content={"Posso utilizar a plataforma com qualquer hospital? "}
          onClick={() => {
            setState((old) => (old = { ...initialState, 4: !old[4] }));
          }}
        >
          Sim. Nosso fluxo não entra no bloco cirúrgico do hospital, mas auxilia
          na marcação com o envio antecipado das guias para os setores de
          pré-agendamento e marcação. A data e hora são escolhidos por contato
          telefônico (do secretariado ou cirurgião) com o setor de marcação do
          hospital. Em nossas futuras atualizações pretendemos aumentar a
          integração da plataforma com a área hospitalar. Lembramos que o
          cadastro completo do hospital só ocorrerá após a primeira indicação
          deste à nossa plataforma, ou seja, na primeira vez uqe o hospital for
          indicado, ele não receberá as guias autorizadas previamente pelo
          plano.
        </FaqDropdown>
        <FaqDropdown
          marginTop={1}
          state={state[5]}
          content={"A utilização da plataforma traz beneficos ao paciente? "}
          onClick={() => {
            setState((old) => (old = { ...initialState, 5: !old[5] }));
          }}
        >
          Sim. O maior de todos é a segurança e controle do processo de
          agendamento. , o paciente será comunicado por e-mail do andamento de
          seu agendamento. disso, estamos pensando constantemente em novos
          beneficios para o paciente.
        </FaqDropdown>
      </Container>
    </Main>
  );
};
